/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:
 */
export default {
  state: {
    isCollapse: false,
    currentUserId: '' //当前登陆账号id（主次）
  },
  mutations: {
    isCollapse(state, v) {
      return (state.isCollapse = v);
    },
    currentUserId(state, v) {
      return (state.currentUserId = v);
    }
  }
};
